import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}xml-stats`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param xmlChannelId
   * @param subChannelId
   * @returns {AxiosPromise}
   */
  getXmlJobs(xmlChannelId, subChannelId) {
    if (!subChannelId) {
      return conduit.get(`/xml-channels/${xmlChannelId}/xml-jobs`);
    }
    return conduit.get(`/xml-channels/${xmlChannelId}/xml-jobs?subChannelId=${subChannelId}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getXmlChannels() {
    return conduit.get('/xml-channels/status');
  },

  /**
   * @returns {AxiosPromise}
   */
  getXmlJobsOverview() {
    return conduit.get('/xml-jobs/overview');
  },

  /**
   * @returns {AxiosPromise}
   */
  activateLatestJob(webservice, subChannel) {
    if (!subChannel) {
      return conduit.get(`/xml-jobs/activate/${webservice}`);
    }
    return conduit.get(`/xml-jobs/activate/${webservice}?sub=${subChannel}`);
  },
  /**
   * @param params
   * @returns {AxiosPromise}
   */
  getRequests(params) {
    const queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    return conduit.get(`/xml-requests?${queryString}`);
  },
  getRequestLogs(id) {
    return conduit.get(`/xml-requests/${id}/logs`);
  },
  /**
   * @param ids
   * @returns {AxiosPromise}
   */
  getProducts(ids) {
    return conduit.post('/xml-channel-products', {
      xmlChannelProductIds: ids,
    });
  },
  /**
   * @param ids
   * @returns {AxiosPromise}
   */
  getChannelProducts(ids) {
    return conduit.post('/xml-channel-products', {
      xmlChannelIds: [ids],
    });
  },
  /**
   * @returns {AxiosPromise}
   */
  getRequestTypes() {
    return conduit.get('/xml-requests/types');
  },
  /**
   * @returns {AxiosPromise}
   */
  getChannels() {
    return conduit.get('/xml-channels');
  },
  /**
   * @param filters
   * @returns {AxiosPromise}
   */
  getPricesImport(xmlJobId, filters) {
    return conduit.post(`/xml-prices/xml-job/${xmlJobId}`, filters);
  },
  /**
   * @param filters
   * @returns {AxiosPromise}
   */
  getPricesPush(xmlChannelProductId, filters) {
    return conduit.post(`/xml-prices/push-product/${xmlChannelProductId}`, filters);
  },
};



// WEBPACK FOOTER //
// ./src/services/xml-stats-service.js